import type { SVGProps } from 'react';
import * as React from 'react';

const DwtIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width={40} height={44} viewBox="0 0 40 44" fill="none" aria-hidden="true" {...props}>
    <g id="file-icon/dwt">
      <g id="Vector" filter="url(#filter0_dd_3816_38147)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M26.2223 1L35.3334 10.1111V38.3333C35.3334 39.8061 34.1505 41 32.6777 41C27.0142 41 13.7443 41 7.32677 41C5.85401 41 4.66675 39.82 4.66675 38.3473C4.66675 30.3468 4.66675 10.7752 4.66675 3.6498C4.66675 2.17704 5.86066 1 7.33341 1H26.2223Z"
          fill="#1E40AF"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M26.2223 1L35.3334 10.1111V38.3333C35.3334 39.8061 34.1505 41 32.6777 41C27.0142 41 13.7443 41 7.32677 41C5.85401 41 4.66675 39.82 4.66675 38.3473C4.66675 30.3468 4.66675 10.7752 4.66675 3.6498C4.66675 2.17704 5.86066 1 7.33341 1H26.2223Z"
          fill="url(#paint0_radial_3816_38147)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M26.2223 1L26.2223 7.44444C26.2223 8.9172 27.4162 10.1111 28.889 10.1111L35.3334 10.1111L26.2223 1Z"
          fill="white"
          fillOpacity={0.3}
        />
      </g>
      <g id="Vector_2">
        <path d="M17.3334 15.8889H35.3334V17.2222H17.3334V15.8889Z" fill="white" />
        <path d="M4.66675 15.8889H10.6667V17.2222H4.66675V15.8889Z" fill="white" />
        <path d="M14.6668 19.8889V29.2222H13.3334V19.8889H14.6668Z" fill="white" />
        <path d="M14.6668 1L14.6667 13.2222H13.3334L13.3334 1L14.6668 1Z" fill="white" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.2253 14.3333H11.7779V18.7778H16.2253V14.3333ZM10.6667 13.2222V19.8889H17.3364V13.2222H10.6667Z"
          fill="white"
        />
        <path d="M14.668 15.8889V17.2222H13.3341V15.8889H14.668Z" fill="white" />
      </g>
      <path
        id="Vector_3"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.2223 26.3334L35.3334 32.3334V38.3334C35.3334 39.8061 34.1505 41 32.6777 41C27.0142 41 13.7443 41 7.32677 41C5.85401 41 4.66675 39.8201 4.66675 38.3473C4.66675 34.7913 4.66675 33.4588 4.66675 26.3334C4.66675 26.3334 10.8157 26.3334 14.2223 26.3334Z"
        fill="#FACC15"
      />
    </g>
    <defs>
      <filter
        id="filter0_dd_3816_38147"
        x={2.66675}
        y={0}
        width={34.6667}
        height={44}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation={0.5} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3816_38147" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
        <feBlend mode="normal" in2="effect1_dropShadow_3816_38147" result="effect2_dropShadow_3816_38147" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_3816_38147" result="shape" />
      </filter>
      <radialGradient
        id="paint0_radial_3816_38147"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(20.0001 0.999999) rotate(90) scale(40 40.1825)"
      >
        <stop offset={0.297418} stopOpacity={0} />
        <stop offset={1} stopOpacity={0.08} />
      </radialGradient>
    </defs>
  </svg>
);
export default DwtIcon;
